module.exports = __webpack_public_path__ + "img/20.21518a3b.jpg";